import './ReleaseButton.css';

interface ReleaseButtonProps {
  onRelease: () => void;
  disabled: boolean;
  /** The market Jeff is currently mulling over, if he named one. */
  asset?: string | null;
}

/**
 * The entire input surface of the product.
 *
 * There was once a form here, and then a three-line creed under it. Both went.
 * Anything a user has to read before pressing this is something standing
 * between them and the joke, and the joke is that no thinking is involved.
 *
 * It does carry the market while Jeff is out, though. Naming it on the way in —
 * "JEFF IS CONSIDERING DOGE" — is the setup; the verdict card is the punchline.
 * Reading it afterwards is a fact, reading it beforehand is a joke.
 */
export function ReleaseButton({ onRelease, disabled, asset }: ReleaseButtonProps) {
  const busyLabel = asset ? `JEFF IS CONSIDERING ${asset}` : 'JEFF IS WORKING';
  return (
    <button
      type="button"
      className="btn btn--primary btn--lg release__btn"
      onClick={onRelease}
      disabled={disabled}
    >
      {disabled ? busyLabel : 'RELEASE JEFF'}
    </button>
  );
}
